module.exports = __webpack_public_path__ + "img/arrow-up-down.6f23ccda.svg";